export const MisionVision = [
    {
        id: 1,
        aos: "fade-right",
        titulo: "Misión",
        texto: "En el año 2022 seremos una universidad donde lo espiritual es tan importante como lo académico, con un sistema certificado y acreditado de educación superior, para el desarrollo intelectual, ético y moral de profesionales que contribuyan a la construcción de una nueva sociedad.",
    },
    {
        id: 2,
        aos: "fade-left",
        titulo: "Visión",
        texto: "Garantizar la presencia del catolicismo en la educación superior de Honduras y asegurar una formación integral en función de las distintas dimensiones del ser humano: lo social, lo moral, lo espiritual, lo científico, lo técnico y lo religioso. ",
    }
]